import Spinner from 'common/spinner/components/spinner';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { getCachedToken, getToken, login } from 'utils/cops-authenticator';

const LoginProvider = ({ children }) => {
    const [loading, setLoading] = useState(true);
    const [noTokenFound, setNoTokenFound] = useState(false);

    useEffect(() => {
        let isFetchingToken = false;

        const fetchTokenAsync = async () => {
            try {
                isFetchingToken = true;
                const newToken = await getToken().catch((err) => {
                    // eslint-disable-next-line no-console
                    console.error(err);
                });
                if (!newToken) {
                    login();
                }
                setNoTokenFound(!newToken);
                setLoading(false);
                isFetchingToken = false;
            } catch (err) {
                setLoading(false);
                isFetchingToken = false;
                // eslint-disable-next-line no-console
                console.error(err);
            }
        };

        const checkAndFetchToken = async () => {
            if (!isFetchingToken) {
                const token = await getCachedToken();
                if (!token && !noTokenFound) {
                    await fetchTokenAsync();
                }
            }
        };

        checkAndFetchToken();
    }, []);

    const token = getCachedToken();
    if (loading && !token && !noTokenFound) {
        return <Spinner title='Loading' />;
    }

    if (!token) {
        return <Spinner title='Redirecting to login...' />;
    }

    return children;
};

LoginProvider.propTypes = {
    children: PropTypes.object,
};

export default LoginProvider;
